import { render, staticRenderFns } from "./envia-trilha-form.vue?vue&type=template&id=ba0cf65a&scoped=true"
import script from "./envia-trilha-form.vue?vue&type=script&lang=js"
export * from "./envia-trilha-form.vue?vue&type=script&lang=js"
import style0 from "./envia-trilha-form.vue?vue&type=style&index=0&id=ba0cf65a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0cf65a",
  null
  
)

export default component.exports